import type { JSX } from 'solid-js';
import { Match, Switch } from 'solid-js';
import { t } from '../i18n';
import { StatusPill } from './StatusPill';

// Who the dashboard is acting as. Presenter only — the caller passes the
// resolved login (from `useMe`); fetching stays in the container
// (apps/dashboard/CLAUDE.md → containers vs presenters).

export type SessionBadgeProps = {
  /** Signed-in account's GitHub login, or `null` when there's no session. */
  readonly login: string | null;
  /**
   * Session still resolving. Show a neutral state instead of "Signed out" so a
   * pending `useMe()` doesn't briefly misreport the account as signed out.
   */
  readonly loading?: boolean;
};

export function SessionBadge(props: SessionBadgeProps): JSX.Element {
  const tone = (): 'success' | 'neutral' => (!props.loading && props.login ? 'success' : 'neutral');
  return (
    <span class="session-badge" role="status">
      <StatusPill tone={tone()}>
        <Switch fallback={t('session.signed_out')}>
          <Match when={props.loading}>{t('session.loading')}</Match>
          <Match when={props.login}>
            {(login) => t('session.signed_in_as', { login: login() })}
          </Match>
        </Switch>
      </StatusPill>
    </span>
  );
}
